import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_API_URL}/api`;

function readInviteCode(search) {
  const params = new URLSearchParams(search || "");
  const raw = String(params.get("invite") || "").trim();
  return raw || "";
}

function clearInviteParam(location, navigate) {
  const params = new URLSearchParams(location.search || "");
  if (!params.has("invite")) return;
  params.delete("invite");
  const nextSearch = params.toString();
  navigate(
    {
      pathname: location.pathname,
      search: nextSearch ? `?${nextSearch}` : "",
    },
    { replace: true },
  );
}

export function buildRegisterWithInviteUrl(code) {
  const normalized = String(code || "").trim();
  if (!normalized) return "/register";
  return `/register?invite=${encodeURIComponent(normalized)}`;
}

export function usePostRegisterInvite() {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const inFlightRef = useRef(false);
  const handledCodeRef = useRef("");

  useEffect(() => {
    const inviteCode = readInviteCode(location.search);
    if (!inviteCode || !user?.user_id || inFlightRef.current) return;
    if (handledCodeRef.current === inviteCode) return;

    inFlightRef.current = true;
    axios
      .post(
        `${API}/invite/${encodeURIComponent(inviteCode)}/redeem`,
        {},
        { withCredentials: true },
      )
      .then(() => {
        handledCodeRef.current = inviteCode;
        clearInviteParam(location, navigate);
        toast.success("Benefit undangan berhasil diaktifkan.");
      })
      .catch((err) => {
        const status = err?.response?.status;
        if (status === 404 || status === 409 || status === 410) {
          handledCodeRef.current = inviteCode;
          clearInviteParam(location, navigate);
        }
      })
      .finally(() => {
        inFlightRef.current = false;
      });
  }, [location, navigate, user?.user_id]);
}
